<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <form>
          <card>
            <template slot="header">
              <h3 class="card-title">{{$t('clarifications.request_for_clarifications')}}</h3>
            </template>
            <h4 v-if="application.application_id">Your reference: {{application.reference}}</h4>
            <div class="row">
              <div class="col-lg-12">
                <question-box v-if="application.application_id" :application="application"></question-box>
              </div>
            </div>
          </card>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import {ApplicationService} from '@/services';
  import swal from 'sweetalert2';
  import {QuestionBox} from 'src/components';

  export default {
    components: {
      QuestionBox
    },
    data() {
      return {
        application: {},
        clarification: {
        },
        questions: [],
        applicationId: parseInt(this.$route.params.applicationId)
      }
    },
    methods: {
      async getApplication() {
        let vm = this;
        let loader = vm.$loading.show();
        await ApplicationService.getApplicationLight(vm.applicationId).then(function(response) {
          vm.application = response.data;
        })

        loader.hide();
      }
    },
    mounted() {
      let vm = this;
      vm.getApplication();
    }
  };
</script>
<style lang="scss" scoped>
  .lang-input {
    width: 80%;
  }

  .flag-icon {
    font-size: 1.5rem;
  }

  .mail-sample-image {
    img {
      max-width: 80%;
    }
  }

  textarea {
    width: 100%;
    resize: both;
    max-height: none !important;
    height: 150px;

    &.subject, &.textarea-email {
      height: auto !important;
      width: 100%;
    }
  }
</style>
